angular.module('nv.routes.other', ['ui.router']);
